<template>
  <section
    class="flex flex-col justify-center p-3 mt-4 w-full font-medium rounded-md border border-solid"
  >
    <div class="w-full">
      <h2 class="leading-none text-black">{{ title }}</h2>
      <div
        class="flex flex-col items-start mt-4 w-full leading-none text-gray-900"
      >
        <ResourceCard
          :icon="wordIcon"
          text="Word Doc"
          width="197px"
          resourceType="word-doc"
          @card-click="handleCardClick"
          @download-click="handleDownloadClick"
        />
        <ResourceCard
          :icon="powerpointSlidesIcon"
          text="Powerpoint Slides"
          width="197px"
          resourceType="powerpoint-slides"
          class="mt-3"
          @card-click="handleCardClick"
          @download-click="handleDownloadClick"
        />
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import ResourceCard from "./ResourceCard.vue";
import { ResourceData } from "@/types/resource_types";
import wordIcon from "@/assets/shared/word-doc-icon.svg";
import googleDocIcon from "@/assets/shared/google-doc-icon.svg";
import powerpointSlidesIcon from "@/assets/shared/powerpoint-slides-icon.svg";
import googleSlidesIcon from "@/assets/shared/google-slides-icon.svg";

export default defineComponent({
  name: "ResourceSection",
  components: {
    ResourceCard,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  setup(props, { emit }) {
    const handleCardClick = (data: ResourceData): void => {
      emit("card-click", data);
    };

    const handleDownloadClick = (data: ResourceData): void => {
      emit("download-click", data);
    };

    return {
      wordIcon,
      googleDocIcon,
      powerpointSlidesIcon,
      googleSlidesIcon,
      handleCardClick,
      handleDownloadClick,
    };
  },
});
</script>
